module.exports = __webpack_public_path__ + "static/media/05.c4eef6b2.jpg";